import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, UncontrolledTooltip ,Tooltip} from "reactstrap";
import { getScreenAppUrl } from "../../app/helpers/urlHelper";
import { translationHookOptions } from "../../app/localization/localization";
import { IScreenStatus } from "../../app/models/screens";
import GenericModal from "../common/GenericModal";
import { toast } from "react-toastify";

interface IParams {
  screen: IScreenStatus;
}

export const UrlButton: React.FC<IParams> = ({ screen }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleCopy = async (screenurl: string) => {
   var _url= getScreenAppUrl() + "/" + screenurl; 
    await navigator.clipboard.writeText(_url);
    toast.success(t("screens_url_copy"));

  }
  




  return (
    <>
      <Button
        id={`urlschermo${screen.id}`}
        onClick={() => setIsModalOpen(true)}
        // className="screenListButton"  //cossì il tooltip sta vicino al bottone
        color="none"
      >
        <i className="fas fa-link fa-2x text-default iconBoxList"></i>
      </Button>
      <UncontrolledTooltip
        delay={0}
        placement="left"
        target={`urlschermo${screen.id}`}
      >
        {t("screens_modal_table_url_tooltip")}
      </UncontrolledTooltip>
      <GenericModal
        title={t("screens_url_modal_title")}
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        content={
                  <>
              <div style={{display:"flex", marginBottom:"2%"}}>
                  <div>
                  <Button
              id={`urlschermo_copy${screen.id}`}
              onClick={() => handleCopy(screen.url)}
              color="none"
            >
              <span className="btn-inner--icon">
               <i className="fas fa-clipboard fa-lg"></i>
               </span>
            </Button>
            <UncontrolledTooltip
              delay={0}
              placement="bottom"
              target={`urlschermo_copy${screen.id}`}
            >
              {t("tooltip_url_copy")}
            </UncontrolledTooltip>

            </div>
            <div style={{marginTop:"1%"}}><h5>{getScreenAppUrl()}/{screen.url}</h5></div>
            </div>
          </>
        }
        cancelBtn={false}
        // size="sm"
      />
    </>
  );
};

export default observer(UrlButton);
